import {
  Box,
  ComboboxItem,
  Fieldset,
  Grid,
  LoadingOverlay,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { repositoryDelivery } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDmMasterOrg } from "../../../../model/TblDMBranch";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
} from "../../../../service/getSelectApi";

const DetailDataView = ({ id }: DetailDataViewProps) => {
  const entity = {
    id: 0,
    code: null,
    name: null,
    address: null,
    phone: null,
    fax: null,
    email: null,
    note: null,
    location: null,
    road: null,
    province: null,
    country: null,
    channelcode: null,
    isonline: null,
    masterInventoryOrg: null,
    guarantee: null,
    orgId: null,
    townName: null,
    provinceId: null,
    companyCode: null,
    attribute1: null,
    attribute2: null,
    attribute3: null,
    attribute4: null,
    attribute5: null,
    attribute6: null,
    attribute7: null,
    attribute8: null,
    attribute9: null,
    attribute10: null,
    attribute11: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [dataProvinceSelectNew, setDataProvinceSelectNew] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneSelectNew, setDataCommuneSelectNew] = useState<
    ComboboxItem[]
  >([]);

  const form = useForm<TblDmMasterOrg>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
  });

  const getDetail = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmMasterOrg/detail?id=${id}`,
    );

    if (res && res.success) {
      const result = res.data;
      form.setValues(result);
      Promise.all([
        fetchDataProvinceNew(),
        fetchDataCommuneNew(result.attribute8),
      ]);
    }
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      const data = res
        ?.filter((item) => item.id && item.name)
        ?.map((item) => ({
          value: String(item.id),
          label: String(item.name),
        }));

      setDataProvinceSelectNew(data);
    }
  };

  const fetchDataCommuneNew = async (id: string, callFirst?: boolean) => {
    const res = await getCommuneSelectNew(id);

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          value: String(item.value),
          label: String(item.text),
        }));

      setDataCommuneSelectNew(data);
    }
  };

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <>
      <Box component="form" mx="auto" style={{ position: "relative" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Mã chi nhánh"
              placeholder="Nhập mã chi nhánh"
              key={form.key("code")}
              {...form.getInputProps("code")}
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="Tên chi nhánh"
              placeholder="Nhập tên chi nhánh"
              key={form.key("name")}
              {...form.getInputProps("name")}
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <Select
              label="Công ty"
              placeholder="Chọn công ty"
              data={[
                { label: "HACOM", value: "HACOM" },
                { label: "DVT", value: "DVT" },
              ]}
              key={form.key("companyCode")}
              {...form.getInputProps("companyCode")}
              readOnly
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              key={form.key("phone")}
              label="SĐT chi nhánh"
              placeholder="Nhập SĐT chi nhánh"
              {...form.getInputProps("phone")}
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              label="SĐT bảo hành"
              placeholder="Nhập SĐT bảo hành"
              key={form.key("attribute1")}
              {...form.getInputProps("attribute1")}
              readOnly
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <TextInput
              key={form.key("attribute11")}
              label="SĐT chi nhánh dùng cho GV"
              placeholder="Nhập SĐT chi nhánh dùng cho GV"
              type="number"
              {...form.getInputProps("attribute11")}
              readOnly
            />
          </Grid.Col>
        </Grid>
        {/* <Fieldset legend="Địa chỉ chi nhánh (Trước khi sáp nhập tỉnh)">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tỉnh/TP"
                placeholder="Chọn tỉnh/thành phố"
                data={dataProvinceSelect}
                value={form.getValues()?.attribute4}
                key={form.key("attribute4")}
                {...form.getInputProps("attribute4")}
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                readOnly
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Quận/huyện"
                placeholder="Chọn quận/huyện"
                data={dataDistrictSelect}
                value={form.getValues()?.attribute5}
                {...form.getInputProps("attribute5")}
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                readOnly
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Phường/Xã"
                placeholder="Chọn phường/xã"
                data={dataCommuneSelect}
                value={form.getValues()?.attribute6}
                {...form.getInputProps("attribute6")}
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                readOnly
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <TextInput
                label="Địa chỉ cụ thể"
                placeholder="Nhập địa chỉ cụ thể"
                key={form.key("attribute7")}
                {...form.getInputProps("attribute7")}
                readOnly
              />
            </Grid.Col>
          </Grid>
        </Fieldset> */}
        {/* <Fieldset legend="Địa chỉ chi nhánh (Sau khi sáp nhập tỉnh)"> */}
        <Fieldset legend="Địa chỉ chi nhánh">
          <Grid>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Tỉnh/TP"
                placeholder="Chọn tỉnh/thành phố"
                data={dataProvinceSelectNew}
                value={form.getValues()?.attribute8}
                key={form.key("attribute8")}
                {...form.getInputProps("attribute8")}
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                readOnly
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
              <Select
                label="Phường/Xã"
                placeholder="Chọn phường/xã"
                data={dataCommuneSelectNew}
                value={form.getValues()?.attribute9}
                {...form.getInputProps("attribute9")}
                searchable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                readOnly
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
                label="Địa chỉ cụ thể"
                placeholder="Nhập địa chỉ cụ thể"
                key={form.key("attribute10")}
                {...form.getInputProps("attribute10")}
                readOnly
              />
            </Grid.Col>
          </Grid>
        </Fieldset>
      </Box>
    </>
  );
};

export default DetailDataView;

type DetailDataViewProps = {
  id: string | number;
};
